export default __webpack_public_path__ + "resources/icons/n442-c0a8.png";